import { render, staticRenderFns } from "./InspectionManagement.vue?vue&type=template&id=22256b36&scoped=true&"
import script from "./InspectionManagement.vue?vue&type=script&lang=js&"
export * from "./InspectionManagement.vue?vue&type=script&lang=js&"
import style0 from "./InspectionManagement.vue?vue&type=style&index=0&id=22256b36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22256b36",
  null
  
)

export default component.exports